import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import DatePicker from "react-datepicker"
import moment from '../../../../helpers/moment'
import { loadLogsAsync } from '../../../../actions/poolDetails'
import PoolShiftsUpdated from './components/poolShiftsUpdated'
import RestaurantsUpdated from './components/restaurantsUpdated'
import DeliveryHoursUpdated from './components/deliveryHoursUpdated'
import PoolRiskLevelChanged from './components/poolRiskLevelChanged'
import PoolNextAvailablePickupChanged from './components/poolNextAvailablePickupChanged'
import DriverPoolPlacedOnline from './components/driverPoolPlacedOnline'
import DriverPoolTakenOffline from './components/driverPoolTakenOffline'
import PoolAvailabilityOverrideChanged from './components/poolAvailabilityOverrideChanged'
import PoolUpdated from './components/poolUpdated'
import Threshold from './components/threshold'
import Pagination from '../../../../components/pagination'
import queryString from 'query-string'
import Loader from '../../../../components/loader'
import PropTypes from 'prop-types'

export class PoolLogs extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      selectedLogEventType: '',
      startDate: null,
      endDate: null,
    }

    this.handleDropdownOnChange = this.handleDropdownOnChange.bind(this);

    this.poolLogEventsType = [
      "DriverPoolEvent",
      "DriverPoolPlacedOnline",
      "DriverPoolPlacedOnlineManually",
      "DriverPoolTakenOffline",
      "DriverPoolTakenOfflineManually",
      "PoolAvailabilityOverrideChanged",
      "PoolLogDeliveryHoursUpdated",
      "PoolRestaurantsUpdated",
      "PoolShiftsUpdated",
      "PoolUpdated",
      "PoolRiskLevel",
      "PoolThresholdUpdated"
    ]

  }

  componentDidMount() {
    this.props.loadLogsAsync({
      id: this.props.id,
      page: this.props.page,
      itemsPerPage: this.props.itemsPerPage,
      user: this.props.user
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const isSamePage = prevProps.page === this.props.page
    const hasSameId = prevProps.id === this.props.id
    const hasSameLogEventType = prevState.selectedLogEventType === this.state.selectedLogEventType

    const previousDateIsNull =  !(prevState.startDate &&  prevState.endDate)
    const currentStateHasDate =  !!(this.state.startDate &&  this.state.endDate)
    const dateFilterEnabled = previousDateIsNull && currentStateHasDate && this.state.endDate

    const hasValidDate = (currentStateHasDate || (!this.state.startDate &&  !this.state.endDate ))

    const shouldUpdateComponentData = (!isSamePage && hasValidDate) || !hasSameId  || !hasSameLogEventType || dateFilterEnabled

    if (shouldUpdateComponentData ) {
      this.props.loadLogsAsync({
        id: this.props.id,
        page: this.props.page,
        itemsPerPage: this.props.itemsPerPage,
        user: this.props.user,
        eventType: this.state.selectedLogEventType,
        occurredStartDate: this.state.startDate ? moment(this.state.startDate).format('YYYY/MM/DD') : '' ,
        occurredEndDate: this.state.endDate ? moment(this.state.endDate).format('YYYY/MM/DD') : ''
      })
    }
  }

  handleDropdownOnChange = ({ target }) => {
    const { value } = target

    this.setState({selectedLogEventType : value})

    this.props.push({search: ''})
  }

  handleDatePickerOnChange(dates) {
    if(!dates)
    {
      this.setState({
        startDate: null,
        endDate: null,
      });

      this.props.loadLogsAsync({
        id: this.props.id,
        page: this.props.page,
        itemsPerPage: this.props.itemsPerPage,
        user: this.props.user,
        eventType: this.state.selectedLogEventType,
      })

      this.props.push({search: ''})
      return;
    }

    const [start, end] = dates

    this.setState({
      startDate: start,
      endDate: end,
    });

    this.props.push({search: ''})
  }

  getDateInputValue () {
    if (this.state.endDate){
      return `${moment(this.state.startDate).format('DD/MM/YYYY')} - ${moment(this.state.endDate).format('DD/MM/YYYY')}}`
    }
    if (this.state.startDate){
      return `${moment(this.state.startDate).format('DD/MM/YYYY')}`
    }

    return ''
  }


  render() {
    let RenderLog = (item) => {
      switch (item.eventType) {
      case 'PoolShiftsUpdated':
        return <PoolShiftsUpdated item={item} key={item.id} />
      case 'PoolRestaurantsUpdated':
        return <RestaurantsUpdated item={item} key={item.id} />
      case 'PoolNextAvailablePickupChanged':
        return <PoolNextAvailablePickupChanged item={item} key={item.id} />
      case 'DriverPoolPlacedOnline':
      case 'DriverPoolPlacedOnlineManually':
        return <DriverPoolPlacedOnline item={item} key={item.id} />
      case 'DriverPoolTakenOffline':
      case 'DriverPoolTakenOfflineManually':
        return <DriverPoolTakenOffline item={item} key={item.id} />
      case 'PoolUpdated':
        return <PoolUpdated item={item} key={item.id} />
      case 'PoolAvailabilityOverrideChanged':
        return <PoolAvailabilityOverrideChanged item={item} key={item.id} />
      case 'PoolLogDeliveryHoursUpdated':
        return <DeliveryHoursUpdated item={item} key={item.id} />
      case 'PoolRiskLevel':
        return <PoolRiskLevelChanged item={item} key={item.id} />
      case 'PoolThresholdUpdated':
        return <Threshold item={item} key={item.id} />
      default: return
      }
    }

    if (this.props.isLoading) return <Loader />

    return <div className="row">
      <div className="col-md-12">
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th className="w15">Type</th>
              <th className="w50">Event</th>
              <th className="w20">Created At</th>
              <th className="w15">Created By</th>
            </tr>
            <tr>
              <th>
                <select
                  className="form-control-sm"
                  value={this.state.selectedLogEventType}
                  onChange={this.handleDropdownOnChange} >
                      <option key="" value="">
                        Any
                      </option>
                      {this.poolLogEventsType.map((logType, index) => (
                        <option key={index} value={logType}>
                          {logType.replace(/([A-Z])/g, ' $1').trim()}
                        </option>
                      ))}
                  </select>
              </th>
              <th />
              <th>
                <DatePicker
                  className='form-control-sm'
                    placeholderText='Filter by date'
                    value={this.getDateInputValue()}
                    selected={this.state.startDate}
                    shouldCloseOnSelect={this.state.startDate && !this.state.endDate}
                    selectsRange={true}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    maxDate={moment().valueOf()}
                    onChange={(update) => {
                      this.handleDatePickerOnChange(update)
                    }}
                    isClearable={true}
                  />
              </th>
              <th />
            </tr>
          </thead>
          <tbody>
            {
              this.props.data.map((item, index) => {
                return RenderLog(item)
              })
            }
          </tbody>
        </table>
        <Pagination url={'/pools/' + this.props.id + '/logs'} totalItems={this.props.totalItems} page={this.props.page} itemsPerPage={this.props.itemsPerPage} />
      </div>
    </div>
  }
}

PoolLogs.propTypes = {
  loadLogsAsync: PropTypes.func.isRequired,
  id: PropTypes.string,
  page: PropTypes.number,
  itemsPerPage: PropTypes.number,
  user: PropTypes.object,
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    eventType: PropTypes.string
  })),
  totalItems: PropTypes.number,
  isLoading: PropTypes.bool,
  push: PropTypes.func.isRequired
}

const mapStateToProps = (state, props) => {
  let currentPage = queryString.parse(state.router.location.search).page ? parseInt(queryString.parse(state.router.location.search).page, 10) : 1
  return {
    id: props.id,
    data: state.poolDetails.logs.data,
    page: currentPage,
    itemsPerPage: state.poolDetails.logs.itemsPerPage,
    totalItems: state.poolDetails.logs.totalItems,
    isLoading: state.poolDetails.logs.isLoading,
    user: state.oidc.user
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  loadLogsAsync,
  push
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PoolLogs)



// WEBPACK FOOTER //
// ./src/containers/pools/details/logs/index.js